import { Link } from 'react-router-dom';
import { categories } from '@/mocks/varietyData';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-3 mb-4 group">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-clapperboard-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-heading font-bold">香蕉影视</span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed">
                香蕉影视致力于提供免费高清综艺娱乐内容，涵盖搞笑综艺、真人秀、脱口秀、音乐综艺等八大品类，高清不缓冲，全集免费看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-white">
                综艺分类
              </h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 6).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-white">
                快速链接
              </h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  联系我们
                </Link>
                <a
                  href="#"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  用户协议
                </a>
                <a
                  href="#"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  隐私政策
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-white">
                联系我们
              </h4>
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-sm text-primary-400"></i>
                  </div>
                  <span className="text-sm text-foreground-300">contact@xiangjiaomedia.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-sm text-primary-400"></i>
                  </div>
                  <span className="text-sm text-foreground-300">400-888-6666</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm text-primary-400"></i>
                  </div>
                  <span className="text-sm text-foreground-300">北京市朝阳区影视产业园A座</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 香蕉影视 xiangjiaomedia.com 版权所有 | 京ICP备2026088888号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line text-base"></i>
                </div>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-weibo-line text-base"></i>
                </div>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-bilibili-line text-base"></i>
                </div>
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-vidicon-line text-base"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}